import "./LiveCommentary.css";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { SoccerMatchStatus } from "../../../../types";
import { useMatchCommentary } from "../../hooks";
import { useFixtureScore } from "../../stores";
import { CommentaryBody, CommentaryHeader } from "./components";
import { useShallow } from "zustand/react/shallow";

export function LiveCommentary() {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  const { match, matchStatus } = useFixtureScore(
    useShallow(({ match, matchStatus }) => ({
      match,
      matchStatus,
    }))
  );

  const currentMatchStatus = matchStatus || match?.status;

  const { data, isLoading } = useMatchCommentary({
    matchId: match?.id || "",
    lang: "en-gb",
    matchStatus: currentMatchStatus || SoccerMatchStatus.FIXTURE,
    kickoffTime: match?.matchDateTime,
  });

  const commentaryFeed = data?.message || [];
  const topMessage = commentaryFeed[0];
  const isCommentaryEmpty = !commentaryFeed.length;
  const isExpandDisabled = isCommentaryEmpty || isLoading;

  // Return early if match commentary is unavailable
  if (
    currentMatchStatus !== SoccerMatchStatus.PLAYING &&
    currentMatchStatus !== SoccerMatchStatus.PLAYED
  ) {
    return <></>;
  }

  return (
    <section className="commentary-container">
      <CommentaryHeader
        title={t("timeline.matchCommentary.title")}
        isExpanded={isExpanded}
        isExpandDisabled={isExpandDisabled}
        onToggle={() => {
          if (!isExpandDisabled && !isCommentaryEmpty) {
            setIsExpanded((prev) => !prev);
          }
        }}
      />
      <CommentaryBody
        isExpanded={isExpanded}
        isLoading={isLoading}
        isEmpty={isCommentaryEmpty}
        topMessage={topMessage}
        feed={commentaryFeed}
        noDataText={t("timeline.matchCommentary.noDataAvailable")}
      />
      <div
        className="commentary-sponsor"
        onClick={() => window.open("https://www.bet365.com.au/hub/en-au/early-payout?affiliate=365_02257052", "_blank", "noopener,noreferrer")}
      >
        <span className="commentary-sponsor-text">Powered by</span>
        <img className="commentary-sponsor-logo" src="/images/bet365-logo-white.svg" alt="bet365" />
        <img className="commentary-sponsor-extra" src="/images/2-goal-early-payout.png" alt="2 Goal Early Payout" />
      </div>
    </section>
  );
}
